import { ArrowUpRight } from "lucide-react";

export const LoanHeading = ({ id, eyebrow, title, children }) => (
  <div className="mb-9 max-w-3xl">
    <p className="loan-eyebrow mb-3">{eyebrow}</p>
    <h2 id={id} data-testid={id} className="text-base font-semibold md:text-lg">{title}</h2>
    {children && <p className="mt-4 text-sm leading-relaxed text-mist">{children}</p>}
  </div>
);

export const LoanAction = ({ placement, children = "Request a loan callback" }) => (
  <a href="#loan-enquiry" data-testid={`loan-cta-${placement}`} className="loan-primary-action">{children}<ArrowUpRight size={17} aria-hidden="true" /></a>
);

export const LoanSource = ({ href, children, testId }) => (
  <a href={href} target="_blank" rel="noopener noreferrer" data-testid={testId} className="loan-source">{children}<ArrowUpRight size={13} aria-hidden="true" /></a>
);

export const LoanField = ({ id, label, children, hint }) => (
  <div className="min-w-0">
    <label htmlFor={id} className="mb-2 block text-xs font-medium text-frost">{label}</label>
    {children}
    {hint && <p id={`${id}-hint`} className="mt-2 text-[11px] leading-relaxed text-mist" data-testid={`${id}-hint`}>{hint}</p>}
  </div>
);